import React from 'react'

import ViewTemplates from "../../../../../../../../../core/manager/view-templates/view-templates"
import FormManager from "../../../../../../../../../core/gd-form/common/form-manager"
import FieldFormElement from "../../../../../../../../../core/fields3/render/form-elemnent"
import FormError from "../../../../../../../../../core/gd-form/common/form-error/form-error"
import ButtonSubmit from "../../../../../../../../../core/gd-form/common/btn-submit/btn-submit-ui5-new"
import {ViewTypeConfigs, ViewTypeSystemConfig} from "../../../../../../../../../core/gd/const/views/view-type-config"
import AddViewPreviewFields from "./fields";
import {ProjectViewAccess} from "../../../../../../../../../core/model2/project-view/@const"
import {
    projectViews_createProjectViewFromConfig
} from "../../../../../../../../../core/model2/project-view/actions/create"
import {ProjectViewConfig} from "../../../../../../../../../core/model2/project-view/@types"
import AddViewRowTitle from "../row-title/row-title"
import {AddView_OptionConfig} from "../../../../../../../../../core/gd-ui/add-view/@types"
import AddView_ViewHeader from "./view-header"
import AddView_SelectView from "./select-view"
import {DEFAULT_TEMPLATE_ID} from "../../../../../../../../../core/manager/app-settings/app-settings"

type Props = {
    config          : AddView_OptionConfig

    hidePopover     : func
    onBack          : func
}

// const debug = "AddViewPreviewDefaultForm"
const debug = false

export default function AddViewPreviewDefaultForm(props: Props) {

    const layoutViewTemplates = new ViewTemplates();
    const templates = layoutViewTemplates.getViewTemplates(props.config.typeId)

    debug && console.log(debug, 'render', templates, props.config.typeId)

    const viewTypeConfig: ViewTypeSystemConfig = ViewTypeConfigs[props.config.typeId as keyof {}]
    const isAddedSingleton = viewTypeConfig.isSingleton && gd.projectViews.getBySystemType(props.config.typeId)[0]

    // Need add ViewType.PROJECT_REPORTS,

    const view = isAddedSingleton ?
        gd.projectViews.getBySystemType(props.config.typeId)[0]
        :
        projectViews_createProjectViewFromConfig(gd.projectViews, {
            systemType: props.config.typeId
        })

    const onOpenView = () => {
        props.hidePopover()
        gd.goTo(view.url)
    }

    const onSubmit = async (values: any) => {
        debug && console.log(debug, 'onSubmit', values, view)

        const viewConfig: ProjectViewConfig = {
            systemType  : props.config.typeId,
            name        : values.name,
            access      : values.access,
            appSettings  : values.templateId ? {templateId: values.templateId} : undefined
        }

        debug && console.log(debug, 'onSubmit params', viewConfig, view)

        const hasNoViews = gd.projectViews.isEmpty
        const newView = await gd.projectViews.createView(viewConfig)

        // When there are no existing project views, the default view opens automatically via a session event.
        // Therefore, we skip calling newView.open() in this case to avoid unnecessary rerenders and unintended loading.hide() call.
        // Only call newView.open({isAutoOpen: true}) if at least one view already exists.
        if (!hasNoViews) {
            newView.open({isAutoOpen: true})
        }

        props.hidePopover()
    }

    const fields = new AddViewPreviewFields(templates)

    const initFormData = {
        name        :  view.name,
        templateId  : DEFAULT_TEMPLATE_ID,
        access      : ProjectViewAccess.PUBLIC,
    }

    const formStructure = {
        fields          : {
            name            : { type: 'input',    isRequired: true},
            templateId      : { type: 'select'},
            access          : { type: 'select'},
        },
        onSubmit        : onSubmit,
        isFormChanged   : true,
    };

    const form = new FormManager(formStructure, initFormData);

    debug && console.log(debug, 'render', view)

    return (
        <div className="flex-column-left-top h-100-percent p-l-10 p-r-10">
            <AddView_SelectView onBack={props.onBack}/>
            <AddView_ViewHeader viewConfig={viewTypeConfig}/>

            {isAddedSingleton &&
                <div className="ui5-notification notification-inline m-t-15">
                    <div className="message fl-ac">
                        <div className="icon ui5-ico-13 ii5-information m-r-10"/>
                        <div className="text flex-row">
                            This view has already been added.
                            <div className="ui5-link-default m-l-10" onClick={onOpenView}>Open view</div>
                        </div>
                    </div>
                </div>}

            {!isAddedSingleton &&
                <>
                    {view.acl.canCreateNew &&
                        <div className="flex-column-left-top w-100-percent m-t-15">
                            <div className="flex-column-left-top w-100-percent">
                                <AddViewRowTitle title="Name" field={fields.name}/>
                                <FieldFormElement className = "w-100-percent"
                                                  field     = {fields.name}
                                                  form      = {form}/>
                                <FormError form = {form}
                                           name = "name"/>
                            </div>

                            {view.hasTemplates &&
                                <div className="flex-column-left-top w-100-percent m-t-15">
                                    <AddViewRowTitle title="Template" field={fields.templateId}/>
                                    <FieldFormElement className = "w-100-percent"
                                                      field     = {fields.templateId}
                                                      form      = {form}/>
                                </div>}

                            <div className="flex-column-left-top w-100-percent m-t-15">
                                <AddViewRowTitle title="Access" field={fields.access}/>
                                <FieldFormElement className = "w-100-percent"
                                                  field     = {fields.access}
                                                  form      = {form}
                                                  options   = {{showIcon: true}}/>
                            </div>
                        </div>}

                    <div className="h-100-percent"/>

                    <div className="flex-row-center-center w-100-percent m-t-30 m-b-30">
                        <ButtonSubmit size="36" form={form} label="Add view"/>
                    </div>
                </>}
        </div>
    );
}
